import { render, staticRenderFns } from "./show.hire-requests.page.vue?vue&type=template&id=64e50a52&scoped=true&"
import script from "./show.hire-requests.page.vue?vue&type=script&lang=js&"
export * from "./show.hire-requests.page.vue?vue&type=script&lang=js&"
import style0 from "./show.hire-requests.page.vue?vue&type=style&index=0&id=64e50a52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e50a52",
  null
  
)

export default component.exports